import ReduxTanStackSync from 'src/new_arch/services/ReduxTanStackSync';
import { PROJECTS_URL, GUEST_HASHES_URL } from '../../../../config/urls';
import Api from '../../../../services/Api';
import { GuestHashJSON } from '../models/guestHash';

export default class GuestHashSystem {
	private api: Api;
	private sync: ReduxTanStackSync;

	constructor( { api, sync }: { api: Api, sync: ReduxTanStackSync } ) {
		this.api = api;
		this.sync = sync;
	}
	async fetchGuestHashes( projectID: number ): Promise<GuestHashJSON[]> {
		const guestHashesUrl = `${PROJECTS_URL}/${projectID}/guest_hashes`;
		const { response } = await ( this.api.get( guestHashesUrl ) as Promise<{ response: GuestHashJSON[] }> );
		return response;
	}

	async updateGuestHash( guestHashID: number, enabled: boolean ): Promise<GuestHashJSON> {
		const guestHashesUrl = `${GUEST_HASHES_URL}/${guestHashID}`;

		const { response } = await (
			this.api.put( guestHashesUrl, { enabled } ) as Promise<{ response: GuestHashJSON }>
		);

		return response;
	}
}
